const reducer = (state, action) => {
    switch (action.type) {
        case 'update':
            return { ...state, ...action.newState };
        case 'refresh':
        case 'sort':
        case 'filter':
            return { ...state, ...action.newState, recOffset: 0, list: [] };
        case 'fetching':
            return { ...state, isFetching: true };
        case 'fetched':
            return { ...state, isFetching: false };
        default:
            return state;
    }
};

export default reducer;
